// extracted by mini-css-extract-plugin
module.exports = {"error":"Demo_error__Yjc7S"};